import { PlaybackUrlConfig, PlaybackOptions } from './storyPlayer.types';

type RecursiveRequired<T> = {
  [P in keyof T]-?: RecursiveRequired<T[P]>;
};

type UrlUtilsConfig = RecursiveRequired<PlaybackUrlConfig>;

export class UrlUtils {
  public disablePlaybackUrlOverride: boolean;
  public config: UrlUtilsConfig;
  public options: PlaybackOptions;

  constructor(playbackUrlConfig: PlaybackUrlConfig = {}, options: PlaybackOptions = {}, disablePlaybackUrlOverride: boolean = false) {
    const defaultPlaybackUrlConfig: UrlUtilsConfig = {
      origin: getEnvironmentOrigin(),
      playbackPath: '/stories',
      params: {
        story: 's',
        playlist: 'p',
        referrer: 'r',
      },
    };
    this.disablePlaybackUrlOverride = disablePlaybackUrlOverride;
    this.config = {
      ...defaultPlaybackUrlConfig,
      ...playbackUrlConfig,
      params: {
        ...defaultPlaybackUrlConfig.params,
        ...playbackUrlConfig.params,
      },
    };
    this.options = options;
  }

  public getPlaybackUrl(storyUrl: string) {
    if (this.disablePlaybackUrlOverride) {
      return storyUrl;
    }

    const {
      lang,
      playlist,
      referrer,
    } = this.options;
    const {
      origin,
      params,
      playbackPath,
    } = this.config;

    const url = `${lang === 'es' ? '/es' : ''}${playbackPath}`;
    const playbackUrl = new URL(url, origin);
    playbackUrl.searchParams.set(params.story, storyUrl);
    if(playlist) {
      playbackUrl.searchParams.set(params.playlist, playlist);
    }
    if(referrer) {
      playbackUrl.searchParams.set(params.referrer, referrer);
    }

    return playbackUrl.toString();
  }

  public getStoryWithPlaybackCanonical(storyUrl: string) {
    if (this.disablePlaybackUrlOverride || !isMlbStory(storyUrl)) {
      return storyUrl;
    }
    const url = new URL(storyUrl);
    url.searchParams.set('canonical', this.getPlaybackUrl(storyUrl));
    return url.toString();
  }
}

export function isMlbStory(storyUrl: string) {
  // MLB hosted stories
  const MLB_STORIES_URL_REGEX = /^https?:\/\/((www.)|(\w+-gcp.))?mlb.com\/(es\/)?stories\/.*/i;
  return MLB_STORIES_URL_REGEX.test(storyUrl);
}

export function getEnvironmentOrigin() {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'https://www.mlb.com';
}
